export default __webpack_public_path__ + "static/media/3k3.1dfb9ff6.png";